import {
  CLEAR_HELLO_SESSION,
  HELLO_ERR,
  HELLO_REQ,
  HELLO_RES,
  LOGOUT,
  POST_LOGIN_ERR,
  POST_LOGIN_REQ,
  POST_LOGIN_RES,
  POST_REGISTER_ERR,
  POST_REGISTER_REQ,
  POST_REGISTER_RES,
  RESTORE_SESSION_REQ,
} from '@/shared/actionTypes';

const INITIAL_STATE = {
  loading: false,
  code: undefined,
  email: undefined,
  auth_token: undefined,
  user_sso_id: undefined,
  code_expires_at: undefined,
  code_duration: undefined,
  cameFromRegistration: false,
};

export const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HELLO_REQ:
      return {
        ...state,
        loading: true,
        email: action.payload.email,
        cameFromRegistration: false,
      };
    case HELLO_RES:
      return {
        ...state,
        loading: false,
        code: action.payload.code,
        code_expires_at: action.payload.expiresAt,
        code_duration: action.payload.duration,
      };
    case HELLO_ERR:
      return {
        ...state,
        loading: false,
        code: undefined,
        code_expires_at: undefined,
        code_duration: undefined,
        cameFromRegistration: false,
      };
    case CLEAR_HELLO_SESSION:
      return {
        ...state,
        loading: false,
        email: undefined,
        code: undefined,
        code_expires_at: undefined,
        code_duration: undefined,
        cameFromRegistration: false,
      };

    case POST_LOGIN_REQ:
      return {
        ...state,
        loading: true,
      };
    case RESTORE_SESSION_REQ:
      return {
        ...state,
        loading: true,
        auth_token: action.payload.auth_token,
        user_sso_id: action.payload.user_sso_id,
      };
    case POST_LOGIN_RES:
      return {
        ...state,
        loading: false,
        auth_token: action.payload.auth_token,
        user_sso_id: action.payload.user_sso_id,
      };
    case POST_LOGIN_ERR:
      return {
        ...state,
        loading: false,
        auth_token: undefined,
        user_sso_id: undefined,
        cameFromRegistration: false,
      };
    case POST_REGISTER_REQ:
      return {
        ...state,
        loading: true,
        cameFromRegistration: true,
      };
    case POST_REGISTER_RES:
      return {
        ...state,
        loading: false,
        code: action.payload.code,
        code_expires_at: action.payload.expiresAt,
        code_duration: action.payload.duration,
        cameFromRegistration: true,
      };
    case POST_REGISTER_ERR:
      return {
        ...state,
        loading: false,
        code: undefined,
        code_expires_at: undefined,
        code_duration: undefined,
        cameFromRegistration: false,
      };

    case LOGOUT:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
